import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Heading, TextLink } from '@frontend/design-system';

export interface FilterSectionHeaderProps {
  title: string;
  noFiltersApplied: boolean;
  onClear: () => void;
}

export const FilterSectionHeader = ({ title, noFiltersApplied, onClear }: FilterSectionHeaderProps) => {
  const { t } = useTranslation('schedule-settings');

  return (
    <div css={containerStyle}>
      <Heading level={3} css={titleStyle}>
        {title}
      </Heading>
      <TextLink size='large' color='primary' weight='bold' disabled={noFiltersApplied} onClick={onClear}>
        {t('Clear')}
      </TextLink>
    </div>
  );
};

const containerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(2),
};

const titleStyle = {
  margin: 0,
};
